// import { useEffect, useState, useRef, useCallback } from "react";
// import { GetDataFromApiWithParams } from "../../../../../services/api/ExecuteApiRequests";
// import IPDCFinalTable from "../../../../../components/IPDCFinalTable";
// import { Box } from "@mui/material";
// import { useNavigate } from "react-router-dom";
// import Button from "@mui/material/Button";
// import MapIcon from "@mui/icons-material/Map";
// import { ToastContainer, toast } from "react-toastify";
// import { UpdateAndGetResponse } from "../../../../../services/api/ExecuteApiRequests";

// export default function ApproveImportedSpatialInfo() {
//   const [unapprovedData, setUnapprovedData] = useState([]);
//   const [unapprovedSplitAndMergeData, setUnapprovedSplitAndMergeData] = useState([]);
//   const componentRef = useRef();
//   const [selectedColumnsImport, setSelectedColumnsImport] = useState([]);
//   const [selectedColumnsSplitMerge, setSelectedColumnsSplitMerge] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [loadingRows, setLoadingRows] = useState({});

//   const navigate = useNavigate();

//   // Utility: convert nested objects to strings
//   const stringifyNestedObjects = (dataArray) => {
//     if (!dataArray || !Array.isArray(dataArray)) return [];
    
//     return dataArray.map(item => {
//       const newItem = {};
//       Object.keys(item).forEach(key => {
//         newItem[key] = (typeof item[key] === "object" && item[key] !== null)
//           ? JSON.stringify(item[key])
//           : item[key];
//       });
//       return newItem;
//     });
//   };

//   // Handle navigation to map view with specific parcel data
//   const handleGoToMap = useCallback((row) => {
//     console.log("📍 CLICKED ROW DATA:", row);
    
//     const mapData = {
//       id: row.id,
//       type: "splitMerge",
//       operationType: row.type_of_edit,
//       rowData: row,
//       spatialData: row.spatial_data || row.geometry || row.parcel_data,
//       originalParcels: row.original_parcels,
//       newParcels: row.new_parcels,
//       parkeId: row.park_id,
//     };

//     navigate("/ViewUnapprovedSplitAndMergeMap", { 
//       state: { 
//         highlightParcel: mapData,
//         source: "splitMerge"
//       }
//     });
//   }, [navigate]);

//   // Create IMPORT data with only Verify and Decline buttons
//   const createImportDataWithActions = useCallback((dataArray) => {
//     if (!dataArray || !Array.isArray(dataArray)) return [];
    
//     return dataArray.map(item => ({
//       ...item,
//       verify: (
//         <Button 
//           variant="contained" 
//           color="success" 
//           size="small"
//           onClick={() => handleApproveImport(item)}
//           disabled={loadingRows[item.id] === 'approve'}
//           sx={{ whiteSpace: 'nowrap', minWidth: '80px' }}
//         >
//           {loadingRows[item.id] === 'approve' ? "Processing..." : "Verify"}
//         </Button>
//       ),
//       decline: (
//         <Button 
//           variant="contained" 
//           color="error" 
//           size="small"
//           onClick={() => handleDeclineImport(item)}
//           disabled={loadingRows[item.id] === 'decline'}
//           sx={{ whiteSpace: 'nowrap', minWidth: '80px' }}
//         >
//           {loadingRows[item.id] === 'decline' ? "Processing..." : "Decline"}
//         </Button>
//       )
//     }));
//   }, [loadingRows]);

//   // Create SPLIT/MERGE data with View Map, Verify, and Decline buttons
//   const createSplitMergeDataWithActions = useCallback((dataArray) => {
//     if (!dataArray || !Array.isArray(dataArray)) return [];
    
//     return dataArray.map(item => ({
//       ...item,
//       viewMap: (
//         <Button 
//           variant="outlined" 
//           color="primary" 
//           size="small"
//           startIcon={<MapIcon />}
//           onClick={() => handleGoToMap(item)}
//           title="View map with highlighted parcels"
//           sx={{ whiteSpace: 'nowrap', minWidth: '100px' }}
//         >
//           View Map
//         </Button>
//       ),
//       verify: (
//         <Button 
//           variant="contained" 
//           color="success" 
//           size="small"
//           onClick={() => handleApprove(item)}
//           disabled={loadingRows[item.id] === 'approve'}
//           sx={{ whiteSpace: 'nowrap', minWidth: '80px' }}
//         >
//           {loadingRows[item.id] === 'approve' ? "Processing..." : "Verify"}
//         </Button>
//       ),
//       decline: (
//         <Button 
//           variant="contained" 
//           color="error" 
//           size="small"
//           onClick={() => handleDecline(item)}
//           disabled={loadingRows[item.id] === 'decline'}
//           sx={{ whiteSpace: 'nowrap', minWidth: '80px' }}
//         >
//           {loadingRows[item.id] === 'decline' ? "Processing..." : "Decline"}
//         </Button>
//       )
//     }));
//   }, [loadingRows, handleGoToMap]);

//   // Handler functions for IMPORT data
//   const handleApproveImport = async (row) => {
//     setLoadingRows(prev => ({ ...prev, [row.id]: 'approve' }));
//     try {
//       const result = await UpdateAndGetResponse(`imports/approveSingle/${row.id}`);
//       if (result) {
//         toast.success("Spatial data import approved successfully!");
//         setUnapprovedData(prevData => prevData.filter(item => item.id !== row.id));
//       } else {
//         toast.error("Failed to approve spatial data import! Please try again.");
//       }
//     } catch (error) {
//       toast.error("Failed to approve spatial data import! Please try again.");
//       console.log(error);
//     } finally {
//       setLoadingRows(prev => ({ ...prev, [row.id]: null }));
//     }
//   };

//   const handleDeclineImport = async (row) => {
//     setLoadingRows(prev => ({ ...prev, [row.id]: 'decline' }));
//     try {
//       const result = await UpdateAndGetResponse(`imports/declineSingle/${row.id}`);
//       if (result) {
//         toast.success("Spatial data import declined successfully!");
//         setUnapprovedData(prevData => prevData.filter(item => item.id !== row.id));
//       } else {
//         toast.error("Failed to decline spatial data import! Please try again.");
//       }
//     } catch (error) {
//       toast.error("Failed to decline spatial data import! Please try again.");
//       console.log(error);
//     } finally {
//       setLoadingRows(prev => ({ ...prev, [row.id]: null }));
//     }
//   };

//   // Handler functions for SPLIT/MERGE data
//   const handleApprove = async (row) => {
//     setLoadingRows(prev => ({ ...prev, [row.id]: 'approve' }));
//     try {
//       const result = await UpdateAndGetResponse(`/splitAndMerge/approveSingle/${row.id}`);
//       if (result) {
//         const message = result.status === 'Splited' 
//           ? "Parcel split approved successfully" 
//           : result.status === 'Merged'
//           ? "Parcel merge approved successfully"
//           : "Parcel operation approved successfully";
        
//         toast.success(message);
//         setUnapprovedSplitAndMergeData(prevData => prevData.filter(item => item.id !== row.id));
//       } else {
//         const errorMessage = row.type_of_edit === 'SPLIT' 
//           ? "Parcel split approval failed!" 
//           : "Parcel merge approval failed!";
        
//         toast.error(errorMessage);
//       }
//     } catch (error) {
//       const errorMessage = row.type_of_edit === 'SPLIT' 
//         ? "Parcel split approval failed!" 
//         : "Parcel merge approval failed!";
      
//       toast.error(errorMessage);
//     } finally {
//       setLoadingRows(prev => ({ ...prev, [row.id]: null }));
//     }
//   };

//   const handleDecline = async (row) => {
//     setLoadingRows(prev => ({ ...prev, [row.id]: 'decline' }));
//     try {
//       const result = await UpdateAndGetResponse(`/splitmerge/decline/${row.id}`);
      
//       if (result) {
//         toast.success("Parcel operation declined");
//         setUnapprovedSplitAndMergeData(prevData => prevData.filter(item => item.id !== row.id));
//       } else {
//         toast.error("Parcel decline failed!");
//       }
//     } catch (error) {
//       console.error("API Error:", error);
//       toast.error("Parcel decline failed!");
//     } finally {
//       setLoadingRows(prev => ({ ...prev, [row.id]: null }));
//     }
//   };

//   useEffect(() => {
//     const fetchAllData = async () => {
//       setLoading(true);
      
//       try {
//         // Fetch Unapproved Import Data
//         const importResult = await GetDataFromApiWithParams("unapprovedSpatialDataApprove");
//         if (importResult && Array.isArray(importResult) && importResult.length > 0) {
//           const formattedImportData = stringifyNestedObjects(importResult);
//           const importDataWithActions = createImportDataWithActions(formattedImportData);
//           setUnapprovedData(importDataWithActions);
          
//           // Get base columns for import data
//           const baseImportColumns = formattedImportData.length > 0 
//             ? Object.keys(formattedImportData[0]).filter(col => !['verify', 'decline', 'viewMap'].includes(col))
//             : [];
          
//           setSelectedColumnsImport([...baseImportColumns, "verify", "decline"]);
//         } else {
//           console.log("No unapproved import data found");
//           setUnapprovedData([]);
//         }

//         // Fetch Unapproved Split/Merge Data
//         const splitMergeResult = await GetDataFromApiWithParams("unapprovedSplitAndMergeDataApprove");
//         if (splitMergeResult && Array.isArray(splitMergeResult) && splitMergeResult.length > 0) {
//           const formattedSplitMergeData = stringifyNestedObjects(splitMergeResult);
//           const splitMergeDataWithActions = createSplitMergeDataWithActions(formattedSplitMergeData);
//           setUnapprovedSplitAndMergeData(splitMergeDataWithActions);
          
//           // Get base columns for split/merge data
//           const baseSplitMergeColumns = formattedSplitMergeData.length > 0 
//             ? Object.keys(formattedSplitMergeData[0]).filter(col => !['verify', 'decline', 'viewMap'].includes(col))
//             : [];
          
//           setSelectedColumnsSplitMerge([...baseSplitMergeColumns, "viewMap", "verify", "decline"]);
//         } else {
//           console.log("No unapproved split/merge data found");
//           setUnapprovedSplitAndMergeData([]);
//         }
//       } catch (error) {
//         console.error("Error fetching data:", error);
//         toast.error("Failed to load data. Please try again.");
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchAllData();
//   }, [createImportDataWithActions, createSplitMergeDataWithActions]);

//   return (
//     <Box sx={{ p: 2 }}>
//       <ToastContainer 
//         position="top-right"
//         autoClose={8000}
//         hideProgressBar={false}
//         newestOnTop={false}
//         closeOnClick={false}
//         rtl={false}
//         pauseOnFocusLoss
//         draggable
//         pauseOnHover
//       />
      
//       {loading ? (
//         <div style={{ textAlign: 'center', padding: '20px' }}>Loading data...</div>
//       ) : (
//         <>
//           {/* Unapproved Import Data Section */}
//           <div style={{ marginBottom: '30px' }}>
//             <h3 style={{ marginBottom: '15px', color: '#333' }}>Unapproved Import Data</h3>
            
//             {unapprovedData.length > 0 ? (
//               <IPDCFinalTable
//                 ref={componentRef}
//                 data={unapprovedData}
//                 setData={setUnapprovedData}
//                 selectedColumns={selectedColumnsImport}
//                 title="Unapproved Import Data"
//                 attachmentLink="file_path"
//                 hasAttachment={true}
//               />
//             ) : (
//               <div style={{ 
//                 padding: '20px', 
//                 backgroundColor: '#f5f5f5', 
//                 borderRadius: '4px',
//                 textAlign: 'center',
//                 color: '#666',
//                 marginBottom: '20px'
//               }}>
//                 No Import Data to approve
//               </div>
//             )}
//           </div>

//           {/* Separator */}
//           <div style={{ 
//             borderBottom: '2px solid #e0e0e0', 
//             margin: '30px 0',
//             width: '100%' 
//           }} />

//           {/* Unapproved Split/Merge Data Section */}
//           <div>
//             <h3 style={{ marginBottom: '15px', color: '#333' }}>Unapproved Split/Merge Data</h3>
            
//             {unapprovedSplitAndMergeData.length > 0 ? (
//               <IPDCFinalTable
//                 ref={componentRef}
//                 data={unapprovedSplitAndMergeData}
//                 setData={setUnapprovedSplitAndMergeData}
//                 selectedColumns={selectedColumnsSplitMerge}
//                 title="Unapproved Split and Merge Data"
//                 attachmentLink="file_path"
//                 hasAttachment={false}
//               />
//             ) : (
//               <div style={{ 
//                 padding: '20px', 
//                 backgroundColor: '#f5f5f5', 
//                 borderRadius: '4px',
//                 textAlign: 'center',
//                 color: '#666'
//               }}>
//                 No Split/Merge Data to approve
//               </div>
//             )}
//           </div>
//         </>
//       )}
//     </Box>
//   );
// }


import { useEffect, useState, useRef, useCallback } from "react";
import { GetDataFromApiWithParams } from "../../../../../services/api/ExecuteApiRequests";
import IPDCFinalTable from "../../../../../components/IPDCFinalTable";
import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Button from "@mui/material/Button";
import MapIcon from "@mui/icons-material/Map";
import { ToastContainer, toast } from "react-toastify";
import { UpdateAndGetResponse } from "../../../../../services/api/ExecuteApiRequests";

export default function ApproveImportedSpatialInfo() {
  const [unapprovedData, setUnapprovedData] = useState([]);
  const [unapprovedSplitAndMergeData, setUnapprovedSplitAndMergeData] = useState([]);
  const componentRef = useRef();
  const [selectedColumnsImport, setSelectedColumnsImport] = useState([]);
  const [selectedColumnsSplitMerge, setSelectedColumnsSplitMerge] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingRows, setLoadingRows] = useState({});

  const navigate = useNavigate();

  // Utility: convert nested objects to strings
  const stringifyNestedObjects = (dataArray) => {
    if (!dataArray || !Array.isArray(dataArray)) return [];
    
    return dataArray.map(item => {
      const newItem = {};
      Object.keys(item).forEach(key => {
        newItem[key] = (typeof item[key] === "object" && item[key] !== null)
          ? JSON.stringify(item[key])
          : item[key];
      });
      return newItem;
    });
  };

  // Handle navigation to map view with specific parcel data
  const handleGoToMap = useCallback((row) => {
    console.log("📍 CLICKED ROW DATA:", row);
    
    const mapData = {
      id: row.id,
      type: "splitMerge",
      operationType: row.type_of_edit,
      rowData: row,
      spatialData: row.spatial_data || row.geometry || row.parcel_data,
      originalParcels: row.original_parcels,
      newParcels: row.new_parcels,
      parkeId: row.park_id,
    };

    navigate("/ViewUnapprovedSplitAndMergeMap", { 
      state: { 
        highlightParcel: mapData,
        source: "splitMerge"
      }
    });
  }, [navigate]);

  // Create IMPORT data with only Verify and Decline buttons - UPDATED STYLING
  const createImportDataWithActions = useCallback((dataArray) => {
    if (!dataArray || !Array.isArray(dataArray)) return [];
    
    return dataArray.map(item => ({
      ...item,
      verify: (
        <Button 
          variant="contained" 
          size="small"
          onClick={() => handleApproveImport(item)}
          disabled={loadingRows[item.id] === 'approve'}
          sx={{ 
            whiteSpace: 'nowrap', 
            minWidth: '80px',
            bgcolor: '#f5f5f5',
            color: '#000',
            '&:hover': {
              bgcolor: '#e0e0e0',
            }
          }}
        >
          {loadingRows[item.id] === 'approve' ? "Processing..." : "Verify"}
        </Button>
      ),
      decline: (
        <Button 
          variant="contained" 
          size="small"
          onClick={() => handleDeclineImport(item)}
          disabled={loadingRows[item.id] === 'decline'}
          sx={{ 
            whiteSpace: 'nowrap', 
            minWidth: '80px',
            backgroundColor: '#f5f5f5',
            color: '#d32f2f',
            '&:hover': {
              backgroundColor: '#e0e0e0',
              color: '#b71c1c',
            },
            '&:disabled': {
              backgroundColor: '#f5f5f5',
              color: '#d32f2f',
              opacity: 0.6,
            }
          }}
        >
          {loadingRows[item.id] === 'decline' ? "Processing..." : "Decline"}
        </Button>
      )
    }));
  }, [loadingRows]);

  // Create SPLIT/MERGE data with View Map, Verify, and Decline buttons - UPDATED STYLING
  const createSplitMergeDataWithActions = useCallback((dataArray) => {
    if (!dataArray || !Array.isArray(dataArray)) return [];
    
    return dataArray.map(item => ({
      ...item,
      viewMap: (
        <Button 
          variant="outlined" 
          color="primary" 
          size="small"
          startIcon={<MapIcon />}
          onClick={() => handleGoToMap(item)}
          title="View map with highlighted parcels"
          sx={{ whiteSpace: 'nowrap', minWidth: '100px' }}
        >
          View Map
        </Button>
      ),
      verify: (
        <Button 
          variant="contained" 
          size="small"
          onClick={() => handleApprove(item)}
          disabled={loadingRows[item.id] === 'approve'}
          sx={{ 
            whiteSpace: 'nowrap', 
            minWidth: '80px',
            bgcolor: '#f5f5f5',
            color: '#000',
            '&:hover': {
              bgcolor: '#e0e0e0',
            }
          }}
        >
          {loadingRows[item.id] === 'approve' ? "Processing..." : "Verify"}
        </Button>
      ),
      decline: (
        <Button 
          variant="contained" 
          size="small"
          onClick={() => handleDecline(item)}
          disabled={loadingRows[item.id] === 'decline'}
          sx={{ 
            whiteSpace: 'nowrap', 
            minWidth: '80px',
            backgroundColor: '#f5f5f5',
            color: '#d32f2f',
            '&:hover': {
              backgroundColor: '#e0e0e0',
              color: '#b71c1c',
            },
            '&:disabled': {
              backgroundColor: '#f5f5f5',
              color: '#d32f2f',
              opacity: 0.6,
            }
          }}
        >
          {loadingRows[item.id] === 'decline' ? "Processing..." : "Decline"}
        </Button>
      )
    }));
  }, [loadingRows, handleGoToMap]);

  // Handler functions for IMPORT data
  const handleApproveImport = async (row) => {
    setLoadingRows(prev => ({ ...prev, [row.id]: 'approve' }));
    try {
      const result = await UpdateAndGetResponse(`imports/approveSingle/${row.id}`);
      if (result) {
        toast.success("Spatial data import approved successfully!");
        setUnapprovedData(prevData => prevData.filter(item => item.id !== row.id));
      } else {
        toast.error("Failed to approve spatial data import! Please try again.");
      }
    } catch (error) {
      toast.error("Failed to approve spatial data import! Please try again.");
      console.log(error);
    } finally {
      setLoadingRows(prev => ({ ...prev, [row.id]: null }));
    }
  };

  const handleDeclineImport = async (row) => {
    setLoadingRows(prev => ({ ...prev, [row.id]: 'decline' }));
    try {
      const result = await UpdateAndGetResponse(`imports/declineSingle/${row.id}`);
      if (result) {
        toast.success("Spatial data import declined successfully!");
        setUnapprovedData(prevData => prevData.filter(item => item.id !== row.id));
      } else {
        toast.error("Failed to decline spatial data import! Please try again.");
      }
    } catch (error) {
      toast.error("Failed to decline spatial data import! Please try again.");
      console.log(error);
    } finally {
      setLoadingRows(prev => ({ ...prev, [row.id]: null }));
    }
  };

  // Handler functions for SPLIT/MERGE data
  const handleApprove = async (row) => {
    setLoadingRows(prev => ({ ...prev, [row.id]: 'approve' }));
    try {
      const result = await UpdateAndGetResponse(`/splitAndMerge/approveSingle/${row.id}`);
      if (result) {
        const message = result.status === 'Splited' 
          ? "Parcel split approved successfully" 
          : result.status === 'Merged'
          ? "Parcel merge approved successfully"
          : "Parcel operation approved successfully";
        
        toast.success(message);
        setUnapprovedSplitAndMergeData(prevData => prevData.filter(item => item.id !== row.id));
      } else {
        const errorMessage = row.type_of_edit === 'SPLIT' 
          ? "Parcel split approval failed!" 
          : "Parcel merge approval failed!";
        
        toast.error(errorMessage);
      }
    } catch (error) {
      const errorMessage = row.type_of_edit === 'SPLIT' 
        ? "Parcel split approval failed!" 
        : "Parcel merge approval failed!";
      
      toast.error(errorMessage);
    } finally {
      setLoadingRows(prev => ({ ...prev, [row.id]: null }));
    }
  };

  const handleDecline = async (row) => {
    setLoadingRows(prev => ({ ...prev, [row.id]: 'decline' }));
    try {
      const result = await UpdateAndGetResponse(`/splitmerge/decline/${row.id}`);
      
      if (result) {
        toast.success("Parcel operation declined");
        setUnapprovedSplitAndMergeData(prevData => prevData.filter(item => item.id !== row.id));
      } else {
        toast.error("Parcel decline failed!");
      }
    } catch (error) {
      console.error("API Error:", error);
      toast.error("Parcel decline failed!");
    } finally {
      setLoadingRows(prev => ({ ...prev, [row.id]: null }));
    }
  };

  useEffect(() => {
    const fetchAllData = async () => {
      setLoading(true);
      
      try {
        // Fetch Unapproved Import Data
        const importResult = await GetDataFromApiWithParams("unapprovedSpatialDataApprove");
        if (importResult && Array.isArray(importResult) && importResult.length > 0) {
          const formattedImportData = stringifyNestedObjects(importResult);
          const importDataWithActions = createImportDataWithActions(formattedImportData);
          setUnapprovedData(importDataWithActions);
          
          // Get base columns for import data
          const baseImportColumns = formattedImportData.length > 0 
            ? Object.keys(formattedImportData[0]).filter(col => !['verify', 'decline', 'viewMap'].includes(col))
            : [];
          
          setSelectedColumnsImport([...baseImportColumns, "verify", "decline"]);
        } else {
          console.log("No unapproved import data found");
          setUnapprovedData([]);
        }

        // Fetch Unapproved Split/Merge Data
        const splitMergeResult = await GetDataFromApiWithParams("unapprovedSplitAndMergeDataApprove");
        if (splitMergeResult && Array.isArray(splitMergeResult) && splitMergeResult.length > 0) {
          const formattedSplitMergeData = stringifyNestedObjects(splitMergeResult);
          const splitMergeDataWithActions = createSplitMergeDataWithActions(formattedSplitMergeData);
          setUnapprovedSplitAndMergeData(splitMergeDataWithActions);
          
          // Get base columns for split/merge data
          const baseSplitMergeColumns = formattedSplitMergeData.length > 0 
            ? Object.keys(formattedSplitMergeData[0]).filter(col => !['verify', 'decline', 'viewMap'].includes(col))
            : [];
          
          setSelectedColumnsSplitMerge([...baseSplitMergeColumns, "viewMap", "verify", "decline"]);
        } else {
          console.log("No unapproved split/merge data found");
          setUnapprovedSplitAndMergeData([]);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        toast.error("Failed to load data. Please try again.");
      } finally {
        setLoading(false);
      }
    };

    fetchAllData();
  }, [createImportDataWithActions, createSplitMergeDataWithActions]);

  return (
    <Box sx={{ p: 2 }}>
      <ToastContainer 
        position="top-right"
        autoClose={8000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      
      {loading ? (
        <div style={{ textAlign: 'center', padding: '20px' }}>Loading data...</div>
      ) : (
        <>
          {/* Unapproved Import Data Section */}
          <div style={{ marginBottom: '30px' }}>
            <h3 style={{ marginBottom: '15px', color: '#333' }}>Unapproved Import Data</h3>
            
            {unapprovedData.length > 0 ? (
              <IPDCFinalTable
                ref={componentRef}
                data={unapprovedData}
                setData={setUnapprovedData}
                selectedColumns={selectedColumnsImport}
                title="Unapproved Import Data"
                attachmentLink="file_path"
                hasAttachment={true}
              />
            ) : (
              <div style={{ 
                padding: '20px', 
                backgroundColor: '#f5f5f5', 
                borderRadius: '4px',
                textAlign: 'center',
                color: '#666',
                marginBottom: '20px'
              }}>
                No Import Data to approve
              </div>
            )}
          </div>

          {/* Separator */}
          <div style={{ 
            borderBottom: '2px solid #e0e0e0', 
            margin: '30px 0',
            width: '100%' 
          }} />

          {/* Unapproved Split/Merge Data Section */}
          <div>
            <h3 style={{ marginBottom: '15px', color: '#333' }}>Unapproved Split/Merge Data</h3>
            
            {unapprovedSplitAndMergeData.length > 0 ? (
              <IPDCFinalTable
                ref={componentRef}
                data={unapprovedSplitAndMergeData}
                setData={setUnapprovedSplitAndMergeData}
                selectedColumns={selectedColumnsSplitMerge}
                title="Unapproved Split and Merge Data"
                attachmentLink="file_path"
                hasAttachment={false}
              />
            ) : (
              <div style={{ 
                padding: '20px', 
                backgroundColor: '#f5f5f5', 
                borderRadius: '4px',
                textAlign: 'center',
                color: '#666'
              }}>
                No Split/Merge Data to approve
              </div>
            )}
          </div>
        </>
      )}
    </Box>
  );
}